<script>
  import { fade } from 'svelte/transition';

  export let project;
  let year = project.year ?? '';
  let neighborhood = project.neighborhood && project.neighborhood.length ? project.neighborhood[0].title : '';
  let designer = project.designer && project.designer.length ? project.designer[0].title : '';
</script>

<tr transition:fade={{duration: 200}}>
  <td>{year}</td>
  <td class="project-table-title lead">
    <a href="{project.url}">{project.title}</a>
  </td>
  <td>{neighborhood}</td>
  <td>{designer}</td>
</tr>
